<template>
	<transition
			appear
			:appear-active-class="$_shtInpDtLyt_stylePageLayoutAnimation()">
		<v-row class="customVRow" no-gutters>
			<v-col>
				<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
					<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
						<v-row :key="contentKey" no-gutters>
							<v-col>
								<template v-if="contentVals.title">
									<v-row justify="center">
										<v-col cols="11" md="9">
											<v-sheet
													class="customVSheet pa-3"
													:color="$_shtInpDtLyt_styleHeaderSheetColor"
													:dark="$_shtInpDtLyt_styleHeaderSheetDark"
													:elevation="$_shtInpDtLyt_styleHeaderSheetElevation"
													:light="$_shtInpDtLyt_styleHeaderSheetLight">
												<v-card color="transparent" flat>
													<v-card-text class="center">
														<center>
															<span	class="headline"
																	v-html="$_shtInpDtLyt_langContentTitle(contentVals)" />
														</center>
													</v-card-text>
												</v-card>
											</v-sheet>
										</v-col>
									</v-row>
								</template>
								<v-row justify="center">
									<v-col cols="11" md="9">
										<v-sheet
												class="customVSheet"
												:color="$_shtInpDtLyt_styleBodySheetColor"
												:dark="$_shtInpDtLyt_styleBodySheetDark"
												:elevation="$_shtInpDtLyt_styleBodySheetElevation"
												:light="$_shtInpDtLyt_styleBodySheetLight">
											<v-card	class="customVCard"
													color="transparent"
													flat>
												<template v-if="isObject(contentVals.bigImage)">
													<v-row>
														<v-col>
															<v-img	class="customVImg"
																	:src="$_shtInpDtLyt_styleContentBigImageUrl(contentVals)" />
														</v-col>
													</v-row>
												</template>
												<template v-if="isObject(contentVals.video)">
													<v-row>
														<v-col>
															<card-video
																	:contentKey="contentKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</v-row>
												</template>
												<template v-if="isObject(contentVals.bigChart)">
													<v-row>
														<v-col>
															<card-big-chart
																	:contentKey="contentKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</v-row>
												</template>
												<v-row>
													<template v-if="isObject(contentVals.image)">
														<v-col cols="12" md="4" class="center">
															<v-img	class="customVImg"
																	:src="$_shtInpDtLyt_styleContentImageUrl(contentVals)" />
														</v-col>
													</template>
													<v-col>
														<template v-if="contentVals.subTitle">
															<v-row no-gutters>
																<v-col>
																	<v-card-title>
																		<span v-html="$_shtInpDtLyt_langContentSubTitle(contentVals)" />
																	</v-card-title>
																</v-col>
															</v-row>
														</template>
														<v-row no-gutters>
															<v-col>
																<v-card-text>
																	<span v-html="$_shtInpDtLyt_langContentText(contentVals)" />
																</v-card-text>
															</v-col>
														</v-row>
														<template v-if="contentVals.actionButtons">
															<v-row no-gutters>
																<v-col>
																	<v-card-actions>
																		<v-row dense>
																			<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																				<v-col :key="actionButtonKey" cols="auto">
																					<v-btn	class="customVBtn"
																							:block="$_shtInpDtLyt_styleActionButtonBlock"
																							:color="$_shtInpDtLyt_styleActionButtonColor"
																							:dark="$_shtInpDtLyt_styleActionButtonDark"
																							:depressed="$_shtInpDtLyt_styleActionButtonDepressed"
																							:elevation="$_shtInpDtLyt_styleActionButtonElevation"
																							:large="$_shtInpDtLyt_styleActionButtonLarge"
																							:light="$_shtInpDtLyt_styleActionButtonLight"
																							:outlined="$_shtInpDtLyt_styleActionButtonOutlined"
																							:rounded="$_shtInpDtLyt_styleActionButtonRounded"
																							:small="$_shtInpDtLyt_styleActionButtonSmall"
																							:text="$_shtInpDtLyt_styleActionButtonFlat"
																							@click="openLink(actionButtonVals.link)"
																							v-text="$_shtInpDtLyt_langActionButtonTitle(actionButtonVals)" />
																				</v-col>
																			</template>
																		</v-row>
																	</v-card-actions>
																</v-col>
															</v-row>
														</template>
													</v-col>
													<template v-if="isObject(contentVals.chart)">
														<v-col cols="12" md="6" class="center">
															<card-chart
																	:contentKey="contentKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</template>
												</v-row>
											</v-card>
										</v-sheet>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputReportLayout',
		props: {
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			// (content)
			$_shtInpDtLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_shtInpDtLyt_langContentSubTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.subTitle;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_shtInpDtLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_shtInpDtLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_shtInpDtLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_shtInpDtLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_shtInpDtLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_shtInpDtLyt_styleHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'headerSheet')
			},
			$_shtInpDtLyt_styleHeaderSheetColor() {
				const self_ = this;
				const headerSheet_ = self_.$_shtInpDtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.color)
			},
			$_shtInpDtLyt_styleHeaderSheetDark() {
				const self_ = this;
				const headerSheet_ = self_.$_shtInpDtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.dark)
			},
			$_shtInpDtLyt_styleHeaderSheetElevation() {
				const self_ = this;
				const headerSheet_ = self_.$_shtInpDtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.elevation)
			},
			$_shtInpDtLyt_styleHeaderSheetLight() {
				const self_ = this;
				const headerSheet_ = self_.$_shtInpDtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.light)
			},
			$_shtInpDtLyt_styleBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'bodySheet')
			},
			$_shtInpDtLyt_styleBodySheetColor() {
				const self_ = this;
				const bodySheet_ = self_.$_shtInpDtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.color)
			},
			$_shtInpDtLyt_styleBodySheetDark() {
				const self_ = this;
				const bodySheet_ = self_.$_shtInpDtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.dark)
			},
			$_shtInpDtLyt_styleBodySheetElevation() {
				const self_ = this;
				const bodySheet_ = self_.$_shtInpDtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.elevation)
			},
			$_shtInpDtLyt_styleBodySheetLight() {
				const self_ = this;
				const bodySheet_ = self_.$_shtInpDtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.light)
			},
			$_shtInpDtLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'actionButton')
			},
			$_shtInpDtLyt_styleActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_shtInpDtLyt_styleActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_shtInpDtLyt_styleActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_shtInpDtLyt_styleActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_shtInpDtLyt_styleActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_shtInpDtLyt_styleActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_shtInpDtLyt_styleActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_shtInpDtLyt_styleActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_shtInpDtLyt_styleActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_shtInpDtLyt_styleActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_shtInpDtLyt_styleActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_shtInpDtLyt_styleActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_shtInpDtLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.bigImage
				}
			},
			$_shtInpDtLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_shtInpDtLyt_styleContentBigImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_shtInpDtLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_shtInpDtLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_shtInpDtLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		methods: {
			$_shtInpDtLyt_convert(dataVals) {
				const self_ = this;

				let result_ = {}

				// order
				result_.order = dataVals.order;

				// answer & score
				result_.isCorrectAnswer = dataVals.isCorrectAnswer;
				result_.score = dataVals.score;

				// question
				result_.question = {}
				result_.question.title = dataVals.question.title;
				result_.question.text = dataVals.question.text;

				// type
				result_.type = dataVals.type;

				// answer
				result_.answerText = null

				// checkbox & radio button & switch -> { 
				// 		"key1": { "value": true / false, "text": "Text" },
				// 		"key2": { "value": true / false, "text": "Text" }
				// }
				if( 	dataVals.type == 'checkbox' || 
						dataVals.type == 'switch' ) {
					Object.keys(dataVals.answer).forEach(key => {
						if(dataVals.answer[key].value) {
							result_.answerText = dataVals.answer[key].text;
						}
					})
				}
				// combobox -> { "order": 1, "text": "Text", "icon": null, "key": "key1" }
				// combobox (texted by user) -> 'text'
				else if(dataVals.type == 'combobox' || 
						dataVals.type == 'radioButton' ) {
					if(self_.isObject(dataVals.answer)) {
						result_.answerText = dataVals.answer.text
					} else {
						result_.answerText = dataVals.answer
					}
				}
				// combobox multiple & select multiple -> [ 
				//		{ "order": 1, "text": "Text", "icon": null, "key": "key1" }, 
				//		{ "order": 2, "text": "Text", "icon": null, "key": "key2" } ]
				// combobox multiple (texted by user) -> [ { "order": 1, "text": "Text", "icon": null, "key": "key1" }, "adfas" ]
				else if(	dataVals.type == 'comboboxMultiple' || 
							dataVals.type == 'selectMultiple' ) {
					result_.answerText = []

					dataVals.answer.forEach(item => {
						if(self_.isObject(item)) { 
							result_.answerText.push(item.text)
						} else {
							result_.answerText.push(item)
						}
					})
				}
				// radio button & select -> { "order": 1, "text": "Text", "icon": null, "key": "key1" }
				else if( dataVals.type == 'select' ) {
					if(self_.isObject(dataVals.answer)) {
						result_.answerText = dataVals.answer.text
					}
				}
				// slider & textarea & text field -> 'text'
				else {
					result_.answerText = dataVals.answer
				}

				return result_
			},
			$_shtInpDtLyt_concatenate(html, item) {
				const self_ = this;
				
				if(self_.isFalse(html)) { html = item }
				else { html = html + '<br>' + item }

				return html
			}
		}
	}
</script>

<style scoped>
</style>
